export interface OpportunityDetails {
    "attachments": FundAttachmentOutputDto[],
    "companyId": string,
    "companyType": string,
    "companyNameAr": string,
    "companynameEn": string,
    "companyName": string,
    "companyDescriptionAr": string,
    "companyDescriptionEn": string,
    "companyDescription": string,
    "companylogoUrl": string,
    "companyAddressAr": string,
    "companyAddressEn": string,
    "companyAddress": string,
    "contactPerson": string,
    "offeringStartDate": Date,
    "offeringEndDate": Date,
    "valuationFrequencyStr": string,
    "contactPhone": string,
    "contactFax": string,
    "contactEmail": string,
    "websiteURL": string,
    "facebookURL": string,
    "linkedInURL": string,
    "twitterURL": string,
    "instagramURL": string,
    "companyLatitude": number,
    "companyLongitude": number,
    "averageRate": number,
    "reviewsCount": number,
    "youTubeURL": string,
    "opportunityid": string,
    "projectTotalValue": number,
    "totalUnits": number,
    "durationPerMonth": number,
    "unitPrice": number,
    "organizerNameAr": string,
    "organizerNameEn": string,
    "organizerName": string,
    "projectIdeaAr": string,
    "projectIdeaEn": string,
    "projectIdea": string,
    "investmentFundId": string,
    "investmentStartDate": Date,
    "investmentEndDate": Date,
    "investmentFundLogoUrl": string,
    "shariahSupervisoryNameAr": string,
    "shariahSupervisoryNameEn": string,
    "shariahSupervisoryName": string,
    "fundType": string,
    "intervalProfit": number,
    "fundingPolicyAr": string,
    "fundingPolicyEn": string,
    "fundingPolicy": string,
    "expectedTotalProfit": string,
    "fundLocationAr": string,
    "fundLocationEn": string,
    "fundLocation": string,
    "subscriptionsNetWorth": string,
    "fundLatitude": number,
    "fundLongitude": number,
    "custodianNameEn": string,
    "custodianNameAr": string,
    "custodianName": string,
    "developer": string,
    "fundManagerNameEn": string,
    "fundManagerNameAr": string,
    "fundManagerName": string,
    "regualatorNameEn": string,
    "regualatorNameAr": string,
    "regualatorName": string,
    "janaCoverageShare": number,
    "minimumInvestment": number,
    "maximumInvestment": number,
    "fundStrategyNameAr": string,
    "fundStrategyNameEn": string,
    "fundStrategyName": string,
    "dividendPolicyen": string,
    "dividendPolicyAr": string,
    "dividendPolicy": string,
    "soldUnits": number,
    "isCompleted": boolean,
    "soldPercentage": number,
    "fundNameEn": string,
    "fundNameAr": string,
    "fundName": string,
    "fundNameWithMultiLine"?: string,
    "isFundClosed": boolean,
    "janaCommission": number,
    "commissionVat": number,
    "isInclusive": boolean,
    "actualUnitPrice": number,
    "commissionPerUnit": number,
    "commissionVatPerUnit": number,
    "isUpcoming": boolean,
    "isAcceptSustainabilityReport": boolean,
    "isAcceptCustomerAcknowledgement": boolean,
    "isInCompleted": boolean,
    "riskLevel": any,
    "riskLevelName": string,
    "coverPhotoURL"?: string,
    "canInvest": boolean,
    "offeringStartDateStr"?: string,
    "offeringEndDateStr"?: string,
    "lastPublishedNav"?: number,
    "lastPricingDate"?: string | Date,
    "valuationFrequency"?: number,
    "cycleCutOffTime"?: string,
    "nextExpectedValuationDate"?: string | Date,
    "priceAtEstablishment"?: number,
    "changeSinceEstablishment"?: number,
    "managementFees"?: number,
    "performanceFees"?: number,
    "minRedemptionUnits"?: number,
    "internalRateOfReturn"?: number,
    "changeSinceLastValuation"?: number,
    "minSubscription"?: number,
    "minAdditionalSubscription"?: number,
    "establishmentDate"?: string | Date,
    "fundCurrency"?: string,
    "subscriptionFees"?: number,
    "redemptionFees"?: number,
    "auditorNameEn"?: string,
    "auditorNameAr"?: string,
    "auditorName"?: string
}
export interface FundAttachmentOutputDto {
    investmentFundId: string;  // Guid -> string in TypeScript
    fundFileTypeId: string;
    fundFileTypeNameAr: string;
    fundFileTypeNameEn: string;
    attachments: AttachmentDto[];  // List<AttachmentDto> -> AttachmentDto[] in TypeScript
}
export interface AttachmentDto {
    id: string;  // Guid -> string in TypeScript
    documentTypeId: string;
    titleAr: string;
    titleEn: string;
    pdfUrlAr: string;
    pdfUrlEn: string;
    linkUrl?: string;
    isUrl?: boolean;
    urlDisplayName?: string;
}
export interface OpportunityBookingSummary {
    "totalAvailableUnits": number,
    "totalSoldUnitsPerInvestor": number,
    "canInvest": boolean,
    "maximumInvestUnits": number,
    "investmentEndDate": Date,
    "minimumInvestUnits": number,
    "miniumumInvestmentAmount": number,
    "finalMaxInvestUnits": number
}
export interface PreBookingFundReport {
    "id": string,
    "investmentFundId": string,
    "nameAr": string,
    "nameEn": string,
    "descriptionAr": string,
    "descriptionEn": string,
}
export interface AcknowledgmentsReport {
    "id": string,
    "titleArabic": string,
    "titleEnglish": string,
    "detailsAr": string,
    "detailsEn": string,
}
export interface UpdateOpportunityTermsInput {
    "isAcceptCustomerAcknowledgement": boolean,
    "isAcceptSustainabilityReport": boolean,
    "opportunityId": string
}
export interface CreateFundBookingInput {
    "shareCount": number | null,
    "unitPrice": number,
    "totalPrice": number,
    "totalPriceWithVatAndCommission": number,
    "opportunityId": string,
    "isAcceptSustainabilityReport": boolean,
    "isAcceptCustomerAcknowledgement": boolean,
    "otp": string,
    "investorSignature"?: string,
    "investmentAmount": number | null,
}
export interface OpportunityItemDto {
    actualUnitPrice: number;
    averageRate: number;
    commissionPerUnit: number;
    commissionVat: number;
    commissionVatPerUnit: number;
    fundStatus: EFundStatus;
    totalAvailableUnits: number;
    offeringEndDate: string;
    offeringStartDate: string;
    companyAddress: string;
    companyAddressAr: string;
    companyAddressEn: string;
    companyDescription: string;
    companyDescriptionAr: string;
    companyDescriptionEn: string;
    companyId: string;
    companyLatitude: number;
    companyLongitude: number;
    companyName: string;
    companyNameAr: string;
    companyType: string;
    companylogoUrl: string | null;
    companynameEn: string;
    contactEmail: string;
    contactFax: string | null;
    contactPerson: string;
    contactPhone: string;
    custodianName: string;
    custodianNameAr: string;
    custodianNameEn: string;
    coverPhotoURL?: string;
    dividendPolicy: string;
    dividendPolicyAr: string;
    dividendPolicyen: string;
    durationPerMonth: number;
    expectedTotalProfit: number;
    facebookURL: string;
    fundLocation: string;
    fundLocationAr: string;
    fundLocationEn: string;
    fundManagerName: string;
    fundManagerNameAr: string;
    fundManagerNameEn: string;
    fundName: string;
    fundNameAr: string;
    fundNameEn: string;
    fundNameWithMultiLine?: string;
    fundStrategyName: string;
    fundStrategyNameAr: string;
    fundStrategyNameEn: string;
    fundType: string;
    fundingPolicy: string;
    fundingPolicyAr: string;
    fundingPolicyEn: string;
    instagramURL: string;
    intervalProfit: number;
    investmentEndDate: string;
    investmentFundId: string;
    investmentFundLogoUrl: string | null;
    investmentStartDate: string;
    isAcceptCustomerAcknowledgement: boolean;
    isAcceptSustainabilityReport: boolean;
    isCompleted: boolean;
    isFundClosed: boolean;
    isInCompleted: boolean;
    isInclusive: boolean;
    isUpcoming: boolean;
    janaCommission: number;
    janaCoverageShare: number;
    linkedInURL: string;
    maximumInvestment: number;
    minimumInvestment: number;
    opportunityid: string;
    organizerName: string | null;
    organizerNameAr: string | null;
    organizerNameEn: string | null;
    projectIdea: string;
    projectIdeaAr: string;
    projectIdeaEn: string;
    projectTotalValue: number;
    regualatorName: string;
    regualatorNameAr: string;
    regualatorNameEn: string;
    reviewsCount: number;
    shariahSupervisoryName: string;
    shariahSupervisoryNameAr: string;
    shariahSupervisoryNameEn: string;
    soldPercentage: number;
    soldUnits: number;
    subscriptionsNetWorth: number | null;
    totalUnits: number;
    twitterURL: string;
    unitPrice: number;
    websiteURL: string;
    youTubeURL: string | null;
    establishmentPrice: number | null;
    ytdPrice: number | null;
    percentageOfChange: number | null;
    lastPublishedNav?: number;
    lastPricingDate?: string | Date;
    valuationFrequency?: number;
    cycleCutOffTime?: string;
    nextExpectedValuationDate?: string | Date;
    priceAtEstablishment?: number;
    changeSinceEstablishment?: number;
    managementFees?: number;
    performanceFees?: number;
    minRedemptionUnits?: number;
    internalRateOfReturn?: number;
    changeSinceLastValuation?: number;
    minSubscription?: number;
    minAdditionalSubscription?: number;
    establishmentDate?: string | Date;
    fundCurrency?: string;
    subscriptionFees?: number;
    redemptionFees?: number;
    riskLevelName?: string;
    auditorNameEn?: string;
    auditorNameAr?: string;
    auditorName?: string;
}
export interface ValidateInvestmentAmountInWalletInput {
    opportunityId: string;
    shareCount: number | null;
    investmentAmount?: number | null;
    unitPrice?: number;
}
export enum FundTypeEnum {
    OpenFund = "OpenFund",
    CloseFund = "CloseFund",

}
export enum EFundStatus {
    Upcoming = "Upcoming",
    Current = "Current",
    Ended = "Ended"
}
export enum RedemptionMode {
  Units_Mode,
  Monetary_Mode,
  Full_Redemption
}